/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

import React from 'react';
import PropTypes from 'prop-types';
import { Icon, Button } from 'sarsaparilla';
import VehicleItem from './VehicleItem';
import { getNewId, equipmentTypes } from '../../utils/utilsNew';

export default class VehicleList extends React.Component {
    static propTypes = {
        vehicles: PropTypes.array,
        handleVehiclesChange: PropTypes.func,
        maxVehicles: PropTypes.number,
        descriptionRequired: PropTypes.bool,
        licensePlateRequired: PropTypes.bool,
        licenseStateRequired: PropTypes.bool,
    };

    static defaultProps = {
        vehicles: [],
    };

    constructor(props) {
        super(props);
        this.addVehicle = this.addVehicle.bind(this);
        this.handleRemove = this.handleRemove.bind(this);
        this.handleChange = this.handleChange.bind(this);
        this.state = {
            total: 0,
        };
    }

    addVehicle(e) {
        e.preventDefault();

        const newVehicleList = [
            ...this.props.vehicles,
            {
                id: getNewId(),
                type: equipmentTypes.get('Vehicle'),
                qty: 1,
                description: '',
                license_plate: '',
                license_state: '',
                removable: true,
            },
        ];

        if (this.isNewVehicleListValid(newVehicleList)) {
            this.props.handleVehiclesChange(newVehicleList);
        }
    }

    isNewVehicleListValid(newList) {
        const total = this.computeVehiclesTotal(newList);
        return (
            total <= this.props.maxVehicles ||
            this.props.maxVehicles === undefined ||
            this.props.maxVehicles === null
        );
    }

    handleRemove(craftId) {
        const newList = this.props.vehicles.slice();
        newList.splice(craftId, 1);
        this.props.handleVehiclesChange(newList);
    }

    handleChange(idx, field, input) {
        const newVehicles = this.props.vehicles.map((eq) => ({ ...eq }));
        const foundEq = newVehicles[idx];
        const readableIndex = idx + 1;

        if (foundEq) {
            switch (field) {
                case `vehicle-qty-${readableIndex}`:
                    foundEq.qty = input;
                    break;
                case `vehicle-description-${readableIndex}`:
                    foundEq.description = input;
                    break;
                case `vehicle-license-plate-${readableIndex}`:
                    foundEq.license_plate = input;
                    break;
                case `vehicle-license-state-${readableIndex}`:
                    foundEq.license_state = input;
                    break;
                default:
                    break;
            }

            if (this.isNewVehicleListValid(newVehicles)) {
                this.props.handleVehiclesChange(newVehicles);
            }
        }
    }

    computeVehiclesTotal(vehicles) {
        if (!vehicles) return 0;

        return vehicles.reduce((total, vehicle) => {
            return total + parseInt(vehicle.qty, 10);
        }, 0);
    }

    render() {
        const {
            vehicles,
            maxVehicles,
            descriptionRequired,
            licensePlateRequired,
            licenseStateRequired,
        } = this.props;

        const vList = vehicles.map((eq, index) => (
            <VehicleItem
                key={`vehicle-item-${index + 1}`}
                vehicle={eq}
                index={index}
                handleChange={this.handleChange}
                handleRemove={this.handleRemove}
                descriptionRequired={descriptionRequired}
                licensePlateRequired={licensePlateRequired}
                licenseStateRequired={licenseStateRequired}
            />
        ));

        return (
            <div className="per-equipment-form per-section-group">
                <div className="rec-order-detail-subsection-title">Vehicle Details</div>
                <p>
                    Please provide information about your vehicle. For rental vehicles,
                    add &quot;rental&quot; in the required fields; if you will not have a
                    vehicle, add &quot;no vehicle.&quot;
                </p>
                <div className="per-total-count-wrapper">
                    <span className="per-total-count">
                        Total Vehicles:{' '}
                        <b>{`${this.computeVehiclesTotal(vehicles)} / ${maxVehicles || 'Unlimited'}`}</b>
                    </span>
                </div>
                <div className="per-form-group">{vList}</div>
                {vehicles.length < maxVehicles && (
                    <div className="rec-form-item-wrap">
                        <Button
                            appearance="link"
                            onClick={this.addVehicle}
                            iconBeforeElement={<Icon iconName="add-circle" />}
                        >
                            Add Vehicle
                        </Button>
                    </div>
                )}
            </div>
        );
    }
}
